import * as actionTypes from 'redux/actions/action-types.js'
import storage from 'localforage'
import { persistReducer } from 'redux-persist'

const initialState = {
    lastFetch: 0,
    loading: false,
}

const awsPersistConfig = {
    key: 'aws',
    storage: storage,
    blacklist: ['loading'],
    migrate: state =>
        Promise.resolve({
            ...state,
            loading: false,
        }),
}

const aws = (state = initialState, action) => {
    const { data, error, type } = action || {}

    switch (type) {
        // case actionTypes.STORE_INIT:
        //     return {
        //         ...initialState,
        //     }
        case actionTypes.AWS_USER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.AWS_USER_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                loginError: null,
                data: {
                    ...data,
                },
                isMaster: data?.attributes ? data.attributes['custom:oxfdm'] === '1' : false,
            }
        case actionTypes.AWS_USER_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                loginError: error,
                lastLoginError: Date.now(),
                data: null,
            }
        case actionTypes.AWS_USER_REQUEST_REFRESH_SUCCESS:
            return {
                ...state,
                loading: false,
                refreshError: null,
                data: {
                    ...data,
                },
                isMaster: data?.attributes ? data.attributes['custom:oxfdm'] === '1' : false,
            }
        case actionTypes.AWS_USER_REQUEST_REFRESH_FAILURE:
            return {
                ...state,
                loading: false,
                refreshError: error,
                lastError: Date.now(),
                data: null,
            }
        case actionTypes.AWS_USER_UPDATE:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.AWS_USER_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                updateError: null,
                lastUpdate: Date.now(),
                data: {
                    ...state.data,
                    attributes: {
                        ...state.data.attributes,
                        ...data,
                    },
                },
            }
        case actionTypes.AWS_USER_UPDATE_FAILURE:
            return {
                ...state,
                loading: false,
                updateError: error,
                lastUpdateError: Date.now(),
            }
        case actionTypes.AWS_USER_REQUEST_CLEAR:
            return initialState
        default: {
            return state
        }
    }
}

export default persistReducer(awsPersistConfig, aws)
